import React, { useEffect, useState, lazy } from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { useVideo } from '../components/VideoContext';
import { WhatsAppWidget } from '../components/WhatsAppWidget';
import { SEO } from '../components/SEO';
const portfolioData = {
  series: [{
    id: 'Epznj_VSFpQ',
    title: 'NPO Zapp - Sinterklaas Journaal Intro 2025',
    thumbnail: 'https://img.youtube.com/vi/Epznj_VSFpQ/maxresdefault.jpg',
    company: 'Blue Rain Productions'
  }, {
    id: 's3hlipr-5YY',
    title: 'Dertigers S6 | BNNVARA | NPO Start',
    thumbnail: 'https://img.youtube.com/vi/s3hlipr-5YY/maxresdefault.jpg',
    company: 'Blue Rain Productions'
  }, {
    id: 'rVgYwUvqnIE',
    title: 'Sleepers seizoen 3 | Trailer | Vanaf 12 december',
    thumbnail: 'https://img.youtube.com/vi/rVgYwUvqnIE/maxresdefault.jpg',
    company: 'Blue Rain Productions'
  }, {
    id: 'dJuw6CWRcZg',
    title: 'Rundfunk: Schwalbe | BNNVARA',
    thumbnail: 'https://img.youtube.com/vi/dJuw6CWRcZg/maxresdefault.jpg',
    company: 'Blue Rain Productions'
  }, {
    id: 'MptDJUUQkkQ',
    title: 'Trailer Woeste Grond | Seizoen 3',
    thumbnail: 'https://img.youtube.com/vi/MptDJUUQkkQ/maxresdefault.jpg',
    company: 'Blue Rain Productions'
  }, {
    id: 'uBo3z53NCmA',
    title: 'Teaser: Willem van Oranje de Musical',
    thumbnail: 'https://img.youtube.com/vi/uBo3z53NCmA/maxresdefault.jpg',
    company: 'Blue Rain Productions'
  }, {
    id: 'z09f_MWGaAc',
    title: 'Tropenjaren S2 | BNNVARA | NPO Start',
    thumbnail: 'https://img.youtube.com/vi/z09f_MWGaAc/maxresdefault.jpg',
    company: 'Blue Rain Productions'
  }, {
    id: 'fwP6gc52qqQ',
    title: 'BODEM - TRAILER | BNNVARA | NPO Start',
    thumbnail: 'https://img.youtube.com/vi/fwP6gc52qqQ/maxresdefault.jpg',
    company: 'Blue Rain Productions'
  }, {
    id: 'qPht50R46Zs',
    title: 'GAAT MIJN DROOM NOG LUKKEN DOOR DE OORLOG?! #1 | Oorlog-stories 2022 | NPO Zapp',
    thumbnail: 'https://img.youtube.com/vi/qPht50R46Zs/maxresdefault.jpg',
    company: 'Blue Rain Productions'
  }, {
    id: 'zhHqHRYCaP4',
    title: 'Sinterklaasjournaal intro 2024',
    thumbnail: 'https://img.youtube.com/vi/zhHqHRYCaP4/maxresdefault.jpg',
    company: 'Blue Rain Productions'
  }, {
    id: 'nm9i5dvYkhI',
    title: 'Een van ons - Trailer - Nu exclusief bij CANAL+',
    thumbnail: 'https://img.youtube.com/vi/nm9i5dvYkhI/maxresdefault.jpg',
    company: 'Blue Rain Productions'
  }, {
    id: 'CUc40AM-P44',
    title: 'OPPASSEN... | Broodje Aap | #8 | NPO Zapp',
    thumbnail: 'https://img.youtube.com/vi/CUc40AM-P44/maxresdefault.jpg',
    company: 'Blue Rain Productions'
  }, {
    id: '4XC9if5mY38',
    title: 'Tropenjaren - TRAILER',
    thumbnail: 'https://img.youtube.com/vi/4XC9if5mY38/maxresdefault.jpg',
    company: 'Blue Rain Productions'
  }, {
    id: 'Zs8qgk_c0Gk',
    title: 'Toen ik je Zag - Officiële Trailer | Royal Servicebioscoop',
    thumbnail: 'https://img.youtube.com/vi/Zs8qgk_c0Gk/maxresdefault.jpg',
    company: 'Blue Rain Productions'
  }, {
    id: 'ViWA_yI2auc',
    title: 'De stamhouder - TRAILER | AVROTROS | NPO Start',
    thumbnail: 'https://img.youtube.com/vi/ViWA_yI2auc/maxresdefault.jpg',
    company: 'Blue Rain Productions'
  }, {
    id: 'C-t88LkuHWQ',
    title: 'Moedermaffia | Nu te zien',
    thumbnail: 'https://img.youtube.com/vi/C-t88LkuHWQ/maxresdefault.jpg',
    company: 'Blue Rain Productions'
  }, {
    id: 'KCyNENuu7g0',
    title: 'Dertigers (seizoen 3) - TRAILER',
    thumbnail: 'https://img.youtube.com/vi/KCyNENuu7g0/maxresdefault.jpg',
    company: 'Blue Rain Productions'
  }, {
    id: 'PffwPgV-dIk',
    title: 'Dertigers (seizoen 4) - TRAILER | BNNVARA | NPO Start',
    thumbnail: 'https://img.youtube.com/vi/PffwPgV-dIk/maxresdefault.jpg',
    company: 'Blue Rain Productions'
  }, {
    id: 'SmO6hd5iDAo',
    title: 'Dertigers | Seizoen 5 | Officiële trailer | BNNVARA',
    thumbnail: 'https://img.youtube.com/vi/SmO6hd5iDAo/maxresdefault.jpg',
    company: 'Blue Rain Productions'
  }, {
    id: 'x5CCGe3rt4o',
    title: 'Dertigers: de kerstfilm brengt het ULTIEME kerstgevoel | BNNVARA | NPO Start',
    thumbnail: 'https://img.youtube.com/vi/x5CCGe3rt4o/maxresdefault.jpg',
    company: 'Blue Rain Productions'
  }, {
    id: 'yTME5EPaKrU',
    title: 'Dochters trailer (2025) | 8 mei in de bioscoop',
    thumbnail: 'https://img.youtube.com/vi/yTME5EPaKrU/maxresdefault.jpg',
    company: 'Blue Rain Productions'
  }, {
    id: 'wU3jJ32ySsI',
    title: 'SILVERSTAR Trailer | Nu verkrijgbaar op VOD | PaardenpraatTV',
    thumbnail: 'https://img.youtube.com/vi/wU3jJ32ySsI/maxresdefault.jpg',
    company: 'Blue Rain Productions'
  }, {
    id: 'cFoYdFfB7fQ',
    title: 'IK WORD GEK VAN DE OORLOG! #2 | Oorlog-stories 2022 | NPO Zapp',
    thumbnail: 'https://img.youtube.com/vi/cFoYdFfB7fQ/maxresdefault.jpg',
    company: 'Blue Rain Productions'
  }, {
    id: 'HJZwpjexCqs',
    title: 'DE OORLOG IS OVER, MAAR IK MOET VLUCHTEN! #3 | Oorlog-stories 2022 | NPO Zapp',
    thumbnail: 'https://img.youtube.com/vi/HJZwpjexCqs/maxresdefault.jpg',
    company: 'Blue Rain Productions'
  }, {
    id: 'e5YVaZ6GPTw',
    title: 'IK ZIT GEVANGEN IN KAMP WESTERBORK #4 | Oorlog-stories 2022 | NPO Zapp',
    thumbnail: 'https://img.youtube.com/vi/e5YVaZ6GPTw/maxresdefault.jpg',
    company: 'Blue Rain Productions'
  }, {
    id: 'UTN0lex2iC8',
    title: 'KILLROOI, DE TUINKABOUTER | Broodje Aap | #1 | NPO Zapp',
    thumbnail: 'https://img.youtube.com/vi/UTN0lex2iC8/maxresdefault.jpg',
    company: 'Blue Rain Productions'
  }, {
    id: 'FrUgj0FOu3o',
    title: 'JATDAG | Broodje Aap | #2 | NPO Zapp',
    thumbnail: 'https://img.youtube.com/vi/FrUgj0FOu3o/maxresdefault.jpg',
    company: 'Blue Rain Productions'
  }, {
    id: 'AS4HDy-aXY4',
    title: 'ALLES IN DE SOEP | Broodje Aap | #3 | NPO Zapp',
    thumbnail: 'https://img.youtube.com/vi/AS4HDy-aXY4/maxresdefault.jpg',
    company: 'Blue Rain Productions'
  }, {
    id: 'BtyYC6V1sLI',
    title: 'ACHTERVOLGD! | Broodje Aap | #4 | NPO Zapp',
    thumbnail: 'https://img.youtube.com/vi/BtyYC6V1sLI/maxresdefault.jpg',
    company: 'Blue Rain Productions'
  }, {
    id: 'xS1nFlMtBIQ',
    title: 'GAME OVER | Broodje Aap | #5 | NPO Zapp',
    thumbnail: 'https://img.youtube.com/vi/xS1nFlMtBIQ/maxresdefault.jpg',
    company: 'Blue Rain Productions'
  }, {
    id: 'JSJNOuVqUng',
    title: 'GEDROGEERDE OUDERS? | Broodje Aap | #6 | NPO Zapp',
    thumbnail: 'https://img.youtube.com/vi/JSJNOuVqUng/maxresdefault.jpg',
    company: 'Blue Rain Productions'
  }, {
    id: 'LaIygKikofo',
    title: 'BROODJE POEP | Broodje Aap | #7 | NPO Zapp',
    thumbnail: 'https://img.youtube.com/vi/LaIygKikofo/maxresdefault.jpg',
    company: 'Blue Rain Productions'
  }, {
    id: 'ztOvIaPbhog',
    title: 'PLAT! | Broodje Aap | #9 | NPO Zapp',
    thumbnail: 'https://img.youtube.com/vi/ztOvIaPbhog/maxresdefault.jpg',
    company: 'Blue Rain Productions'
  }, {
    id: 'wWmSvdSvgOs',
    title: 'ENGE APPJES | Broodje Aap | #10 | NPO Zapp',
    thumbnail: 'https://img.youtube.com/vi/wWmSvdSvgOs/maxresdefault.jpg',
    company: 'Blue Rain Productions'
  }, {
    id: '1jYzdt6qM-o',
    title: 'CHEESY | Broodje Aap | #11 | NPO Zapp',
    thumbnail: 'https://img.youtube.com/vi/1jYzdt6qM-o/maxresdefault.jpg',
    company: 'Blue Rain Productions'
  }, {
    id: '-beQqzNV274',
    title: 'TERROR ZUSJE | Broodje Aap | #12 | NPO Zapp',
    thumbnail: 'https://img.youtube.com/vi/-beQqzNV274/maxresdefault.jpg',
    company: 'Blue Rain Productions'
  }, {
    id: 'tF6liY4TYkw',
    title: 'TELEFOONSTALKER | Broodje Aap | #13 | NPO Zapp',
    thumbnail: 'https://img.youtube.com/vi/tF6liY4TYkw/maxresdefault.jpg',
    company: 'Blue Rain Productions'
  }, {
    id: 'OQcn7VBH4B8',
    title: 'BIZARRE DATE | Broodje Aap | #14 | NPO Zapp',
    thumbnail: 'https://img.youtube.com/vi/OQcn7VBH4B8/maxresdefault.jpg',
    company: 'Blue Rain Productions'
  }, {
    id: 'P7x12eO9xL4',
    title: 'HORRORCLOWN | Broodje Aap | #15 | NPO Zapp',
    thumbnail: 'https://img.youtube.com/vi/P7x12eO9xL4/maxresdefault.jpg',
    company: 'Blue Rain Productions'
  }],
  videoclips: [{
    id: 'sxQ3F_-3UEc',
    title: 'FeestDJRuud - Lonely at the Tap (OFFICIAL VIDEO)',
    thumbnail: 'https://img.youtube.com/vi/sxQ3F_-3UEc/maxresdefault.jpg',
    company: 'Blue Rain Productions'
  }, {
    id: 'pZvz4X_ayQ4',
    title: 'W&W x Blasterjaxx - Let The Music Take Control (Official Video)',
    thumbnail: 'https://img.youtube.com/vi/pZvz4X_ayQ4/maxresdefault.jpg',
    company: 'Blue Rain Productions'
  }, {
    id: '161apPdhOWg',
    title: 'Gerard Joling feat. Poke – We Gaan Raket Nu (Officiële Video)',
    thumbnail: 'https://img.youtube.com/vi/161apPdhOWg/maxresdefault.jpg',
    company: 'Blue Rain Productions'
  }, {
    id: 'LP2Helvgrqw',
    title: 'ChildsPlay & Cimo Fränkel - Always',
    thumbnail: 'https://img.youtube.com/vi/LP2Helvgrqw/maxresdefault.jpg',
    company: 'Blue Rain Productions'
  }, {
    id: 'xqAqaLV8Nf4',
    title: 'Lucas & Steve - Up Till Dawn (On The Move) [Official Music Video]',
    thumbnail: 'https://img.youtube.com/vi/xqAqaLV8Nf4/maxresdefault.jpg',
    company: 'Blue Rain Productions'
  }, {
    id: 'eyHSH4AmlQg',
    title: 'Timmy Trumpet x Jebroer x Dr Phunk - Child Of The Devil (Official Music Video)',
    thumbnail: 'https://img.youtube.com/vi/eyHSH4AmlQg/maxresdefault.jpg',
    company: 'Blue Rain Productions'
  }, {
    id: 'miPMQ544vM0',
    title: 'W&W x Armin van Buuren – Ready To Rave (Official Video)',
    thumbnail: 'https://img.youtube.com/vi/miPMQ544vM0/maxresdefault.jpg',
    company: 'Blue Rain Productions'
  }, {
    id: '24xpoanZakA',
    title: 'ChildsPlay x SJAAK - Tractor (Official Music Video)',
    thumbnail: 'https://img.youtube.com/vi/24xpoanZakA/maxresdefault.jpg',
    company: 'Blue Rain Productions'
  }, {
    id: 'CN149EsQPys',
    title: 'Frsh x ChildsPlay x Spens - Bingo [Official Music Video]',
    thumbnail: 'https://img.youtube.com/vi/CN149EsQPys/maxresdefault.jpg',
    company: 'Blue Rain Productions'
  }, {
    id: '8OAkpItqY5g',
    title: 'ChildsPlay x Valsbezig - Salsa (Official Music Video)',
    thumbnail: 'https://img.youtube.com/vi/8OAkpItqY5g/maxresdefault.jpg',
    company: 'Blue Rain Productions'
  }, {
    id: 'ckdTxsYi0aM',
    title: 'ALI B – LEIPE MOCRO FLAVOUR (2021 REMIX) (PROD. KUBILAY KAYA & BROWNIE DUTCH)',
    thumbnail: 'https://img.youtube.com/vi/ckdTxsYi0aM/maxresdefault.jpg',
    company: 'Blue Rain Productions'
  }],
  commercials: [{
    id: 'Ku0TR4rvYTk',
    title: 'ULTRA EUROPE 2025 - Official Aftermovie',
    thumbnail: 'https://img.youtube.com/vi/Ku0TR4rvYTk/maxresdefault.jpg',
    company: 'Blue Rain Productions'
  }, {
    id: 'JjZs8Do2HgQ',
    title: 'PAROOKAVILLE 2025 | OFFICIAL AFTERMOVIE',
    thumbnail: 'https://img.youtube.com/vi/JjZs8Do2HgQ/maxresdefault.jpg',
    company: 'Blue Rain Productions'
  }, {
    id: '6FbZKXoPNLU',
    title: 'Aftersocks for Charity',
    thumbnail: 'https://img.youtube.com/vi/6FbZKXoPNLU/maxresdefault.jpg',
    company: 'Blue Rain Productions'
  }, {
    id: 'tpSspYS_rj8',
    title: 'Neverland Festival Official 2018 Aftermovie',
    thumbnail: 'https://img.youtube.com/vi/tpSspYS_rj8/maxresdefault.jpg',
    company: 'Blue Rain Productions'
  }, {
    id: 'hhJrLPzB-yk',
    title: 'Syndicate of Vigilantes - Official Trailer',
    thumbnail: 'https://img.youtube.com/vi/hhJrLPzB-yk/maxresdefault.jpg',
    company: 'Blue Rain Productions'
  }, {
    id: 'HF4SgR4wBfk',
    title: 'HOTTUB-BOAT DJ-SET - MR. BELT & WEZOL',
    thumbnail: 'https://img.youtube.com/vi/HF4SgR4wBfk/maxresdefault.jpg',
    company: 'Blue Rain Productions'
  }, {
    id: 'VcrHnu_tiiM',
    title: 'CYCLING THROUGH THE SNOW DJ-SET - MR. BELT & WEZOL',
    thumbnail: 'https://img.youtube.com/vi/VcrHnu_tiiM/maxresdefault.jpg',
    company: 'Blue Rain Productions'
  }, {
    id: 'Gyty_2Vu6F0',
    title: "Mixmash @ Parookaville 2018! | Rockin' With The Best Takeover Aftermovie",
    thumbnail: 'https://img.youtube.com/vi/Gyty_2Vu6F0/maxresdefault.jpg',
    company: 'Blue Rain Productions'
  }, {
    id: 'JlronzPJXrs',
    title: 'Non-stop Feel Good voor jouw dag! | Sky Radio Commercial 2023',
    thumbnail: 'https://img.youtube.com/vi/JlronzPJXrs/maxresdefault.jpg',
    company: 'Blue Rain Productions'
  }]
};
export const ProductiesPage = () => {
  const [activeCategory, setActiveCategory] = useState('series');
  const [hoveredItem, setHoveredItem] = useState<string | null>(null);
  const {
    openVideo
  } = useVideo();
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    checkIfMobile();
    window.addEventListener('resize', checkIfMobile);
    return () => {
      window.removeEventListener('resize', checkIfMobile);
    };
  }, []);
  return <div className="min-h-screen bg-black text-white" data-id="element-429">
      <SEO title="Producties - Blue Rain Productions" description="Bekijk alle film- en tv-producties, videoclips en commercials waaraan Blue Rain Productions heeft meegewerkt. Van producer tot locatiemanagement." data-id="element-430" />
      <Navbar data-id="element-431" />
      <main data-id="element-432">
        <section className="py-32 bg-gradient-to-b from-black to-gray-950 w-full" data-id="element-433">
          <div className="container mx-auto px-4 md:px-6" data-id="element-434">
            <h1 className="text-4xl md:text-6xl font-bold mb-8 text-center" data-id="element-435">
              Producties
            </h1>
            <div className="max-w-2xl mx-auto text-center mb-12 text-gray-300" data-id="element-436">
              <p data-id="element-437">
                Hier een overzicht van alle producties waaraan Blue Rain
                Productions heeft mogen meewerken, van producer tot en met
                locatiemanagement. We zijn trots op onze bijdrage aan het succes
                van deze projecten.
              </p>
            </div>
            <div className="flex flex-wrap justify-center mb-16 mt-12" data-id="element-438">
              <button onClick={() => setActiveCategory('series')} className={`px-6 py-3 mx-2 mb-4 rounded-sm transition-all ${activeCategory === 'series' ? 'bg-blue-600 text-white' : 'bg-transparent text-white border border-gray-700 hover:border-blue-400'}`} data-id="element-439">
                Series & Films ({portfolioData.series.length})
              </button>
              <button onClick={() => setActiveCategory('videoclips')} className={`px-6 py-3 mx-2 mb-4 rounded-sm transition-all ${activeCategory === 'videoclips' ? 'bg-blue-600 text-white' : 'bg-transparent text-white border border-gray-700 hover:border-blue-400'}`} data-id="element-440">
                Videoclips ({portfolioData.videoclips.length})
              </button>
              <button onClick={() => setActiveCategory('commercials')} className={`px-6 py-3 mx-2 mb-4 rounded-sm transition-all ${activeCategory === 'commercials' ? 'bg-blue-600 text-white' : 'bg-transparent text-white border border-gray-700 hover:border-blue-400'}`} data-id="element-441">
                Commercials / Festivals / Promo (
                {portfolioData.commercials.length})
              </button>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="element-442">
              {portfolioData[activeCategory].map(item => <div key={item.id} className="group relative overflow-hidden rounded-sm transform transition-all duration-500 hover:scale-[1.02] hover:shadow-xl cursor-pointer" onClick={() => openVideo(item.id, item.title)} onMouseEnter={() => setHoveredItem(item.id)} onMouseLeave={() => setHoveredItem(null)} data-id="element-443">
                  <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-transparent z-10 opacity-80 group-hover:opacity-70 transition-opacity" data-id="element-444"></div>
                  <img src={item.thumbnail} alt={`${item.title} - Blue Rain Productions`} className="w-full h-72 object-cover transition-transform duration-700 group-hover:scale-110" loading="lazy" data-id="element-445" />
                  <div className={`absolute inset-0 flex items-center justify-center z-20 transition-opacity duration-300 ${hoveredItem === item.id ? 'opacity-100' : 'opacity-0'}`} data-id="element-446">
                    <div className="w-16 h-16 rounded-full bg-blue-600/80 backdrop-blur-sm flex items-center justify-center transform transition-transform duration-300 group-hover:scale-110" data-id="element-447">
                      <svg className="w-6 h-6 text-white ml-1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-448">
                        <path d="M8 5V19L19 12L8 5Z" fill="currentColor" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-449" />
                      </svg>
                    </div>
                  </div>
                  <div className="absolute bottom-0 left-0 right-0 p-6 z-20" data-id="element-450">
                    <h3 className="text-xl font-semibold text-white group-hover:text-blue-400 transition-colors" data-id="element-451">
                      {item.title}
                    </h3>
                    <div className={`mt-3 text-sm text-blue-400 flex items-center transition-all duration-300 ${hoveredItem === item.id ? 'opacity-100' : 'opacity-0'}`} data-id="element-452">
                      Bekijk video
                      <svg className="ml-2 w-4 h-4" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-453">
                        <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-454" />
                      </svg>
                    </div>
                  </div>
                </div>)}
            </div>
            <div className="text-center mt-8 mb-16" data-id="element-455">
              <h2 className="text-2xl md:text-3xl font-bold mb-6" data-id="element-456">
                Heeft u interesse in een productie?
              </h2>
              <p className="text-gray-300 mb-8 max-w-2xl mx-auto" data-id="element-457">
                Neem contact met ons op voor meer informatie over onze diensten
                of om een project te bespreken.
              </p>
              <a href="/#contact" className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-3 rounded-sm transition-colors duration-300 inline-block" data-id="element-458">
                Contact opnemen
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer data-id="element-459" />
      <WhatsAppWidget data-id="element-460" />
    </div>;
};